import { render } from "./couponManagement.vue?vue&type=template&id=76edba7b&scoped=true"
import script from "./couponManagement.vue?vue&type=script&lang=js"
export * from "./couponManagement.vue?vue&type=script&lang=js"

import "./couponManagement.vue?vue&type=style&index=0&id=76edba7b&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76edba7b"]])

export default __exports__